import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";
import { BubzLogo } from "./BubzLogo";

const DISMISS_KEY = "bubz_install_dismissed";

function isStandalone() {
  return window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
}
function isIOS() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;
}

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem(DISMISS_KEY)) return;

    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", onBeforeInstall);

    // iOS Safari has no beforeinstallprompt — show a gentle hint on phones.
    let t;
    if (isIOS()) {
      t = setTimeout(() => { setIosHint(true); setShow(true); }, 2500);
    }
    return () => { window.removeEventListener("beforeinstallprompt", onBeforeInstall); if (t) clearTimeout(t); };
  }, []);

  const dismiss = () => { setShow(false); localStorage.setItem(DISMISS_KEY, "1"); };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try { await deferred.userChoice; } catch { /* noop */ }
    setDeferred(null);
    setShow(false);
    localStorage.setItem(DISMISS_KEY, "1");
  };

  if (!show) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[120] p-3 sm:hidden" data-testid="install-prompt">
      <div className="mx-auto max-w-md rounded-2xl bg-white shadow-2xl border border-amber-100 p-3.5 flex items-center gap-3">
        <span className="h-11 w-11 rounded-xl bg-[#FFFDF7] border border-amber-100 flex items-center justify-center shrink-0">
          <BubzLogo size="xs" />
        </span>
        <div className="flex-1 min-w-0">
          <div className="font-display font-bold text-slate-900 text-sm leading-tight">Add Bubz+ to your home screen</div>
          <div className="text-xs text-slate-500 mt-0.5">
            {iosHint ? "Tap the Share icon, then “Add to Home Screen”." : "Open it like an app — one tap, no app store."}
          </div>
        </div>
        {!iosHint && (
          <button onClick={install} data-testid="install-accept-btn"
            className="shrink-0 inline-flex items-center gap-1.5 rounded-full bg-[#FF5A79] text-white font-bold text-sm px-4 py-2 active:scale-95 transition-transform">
            <Download className="h-4 w-4" /> Install
          </button>
        )}
        <button onClick={dismiss} data-testid="install-dismiss-btn" className="shrink-0 h-8 w-8 rounded-full flex items-center justify-center text-slate-400 hover:bg-slate-100">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
